import React, { Component } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import Utility from '../../../Utility';
import Browser from '../../../Browser'
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../../redux';
import ReactModal from 'react-modal';

import PlaceholderImage from '../../../images/000.jpg';

import { ReactComponent as IconClose } from './VideoWrapperIcons/close.svg';

import './VideoWrapper.css';

const _ = require('lodash');

//   ##     ## #### ########  ########  #######
//   ##     ##  ##  ##     ## ##       ##     ##
//   ##     ##  ##  ##     ## ##       ##     ##
//   ##     ##  ##  ##     ## ######   ##     ##
//    ##   ##   ##  ##     ## ##       ##     ##
//     ## ##    ##  ##     ## ##       ##     ##
//      ###    #### ########  ########  #######

// ##      ## ########     ###    ########  ########  ######## ########
// ##  ##  ## ##     ##   ## ##   ##     ## ##     ## ##       ##     ##
// ##  ##  ## ##     ##  ##   ##  ##     ## ##     ## ##       ##     ##
// ##  ##  ## ########  ##     ## ########  ########  ######   ########
// ##  ##  ## ##   ##   ######### ##        ##        ##       ##   ##
// ##  ##  ## ##    ##  ##     ## ##        ##        ##       ##    ##
//  ###  ###  ##     ## ##     ## ##        ##        ######## ##     ##

class VideoWrapper extends Component {
	constructor(props) {
		super(props);
		this.mediaRef = React.createRef();

		if (this.props.data.useCanvas) {
			this.bufferCanvas = document.createElement('canvas');
			this.bufferCtx = this.bufferCanvas.getContext('2d', { alpha: false });

			// We've tested different image smoothing settings, and leaving it on gives the best results even if they are a bit blurry

			// Set the canvas size equal to the video size
			this.bufferCanvas.width = this.props.data.recording.info.movie_exported_width;
			this.bufferCanvas.height = this.props.data.recording.info.movie_exported_height;

			// Hide when loading on page
			this.bufferCanvas.style.display = 'none';
		}

		this.autoplay = Browser.mobilesafari();

		this.loaded = false;
		this.seeking = false;
		this.seekingDelayTimeUpdateTID = null;

		this.playPause = _.debounce(this.playPause, 50);

		this.state = {
			autoplayPrevented: false
		};

		this.initialLoad = false;
	}

	componentDidMount() {
		// attach somewhere where we can view it:
		// this.bufferCanvas.style.position = 'absolute';
		// this.bufferCanvas.style.zIndex = 200000;
		// this.bufferCanvas.style.top = '720px';
		// this.bufferCanvas.id = 'canvassey';

		if (this.props.data.useCanvas) {
			// Safari 15.0 has a huge memory leak if the buffer canvas isn't on the page
			document.getElementById('tempid').append(this.bufferCanvas);
		}
	}

	handleEvent(event, params) {
		switch(event) {
			case 'play':
				this.play();
				break;

			case 'pause':
				this.pause();
				break;

			case 'playpause':
				this.playPause();
				break;

			case 'backward':
				this.backward();
				break;

			case 'forward':
				this.forward();
				break;

			case 'setPlaybackRate':
				this.setPlaybackRate(params);
				break;

			case 'setVolume':
				this.setVolume(params);
				break;

			case 'seek':
				this.seek(params);
				break;

			case 'seekonly':
				this.seek(params, false);
				break;
			default:
				// Do nothing
				console.log('No handler for "' + event + '" event');
		}
	}

	backward = () => {
		let time = this.mediaRef.current.currentTime-10;
		time = time < 0 ? 0 : time;
		this.seek(time, false);
	}

	forward = () => {
		let time = this.mediaRef.current.currentTime+10;
		if (time < this.mediaRef.current.duration) {
			this.seek(time, false);
		}
	}

	play = () => {
		if (this.loaded === false) { return; }

		var promise = this.mediaRef.current.play();

		// # Safari 11 throws an error if you don't handle the promise
		if (Utility.isPromise(promise)) {
			promise.then(() => {
				// Auto-play started
			}).catch((error) => {
				// Auto-play was prevented
				// Show a UI element to let the user manually start playback
				this.props.updatePlayerState({
					paused: true
				});

				this.setState({ autoplayPrevented: true });
			});
		}
	}

	allowAutoplayButtonClick = () => {
		this.setState({
			autoplayPrevented: false
		});

		this.play();
	}

	pause = () => {
		this.mediaRef.current.pause()
	}

	playPause = () => {
		if (this.loaded === false) { return; }

		if (this.mediaRef.current.paused) {
			let playbackrate = 1;

			// if ended, restart from the beginning
			if (this.mediaRef.current.ended) {
				this.props.updatePlayerState({
					ended: false
				});
				this.mediaRef.current.currentTime = 0;
			}

			// IE, FF reset playbackrate to 1 on play()
			if (!Browser.ios()) {
				playbackrate = this.props.data.playbackRate;
			}

			this.mediaRef.current.play();

			if (!Browser.ios()) {
				this.setPlaybackRate(playbackrate);
			}

			Utility.logUserInteractionNoGA('player_resume', {}, { current_time: this.props.dynamic.currentTime });
		} else {
			this.mediaRef.current.pause();
			Utility.logUserInteractionNoGA('player_pause', {}, { current_time: this.props.dynamic.currentTime });
		}
	}

	seek = (time, autoplay = true) => {
		if (this.loaded === false) { return; }

		if (time === 0 && this.initialLoad === false) {
			// don't try seeking when player first loads
			this.initialLoad = true;
			return;
		}

		// This is used for stats logging
		Utility.emit('player.seek', { from: this.mediaRef.current.currentTime, to: time });
		this.mediaRef.current.currentTime = time;

		this.seekingTime = time;

		if (autoplay === true) {
			this.play();
		}

		if (this.mediaRef.current.paused === false) {
			this.props.updateDynamicState({
				buffering: true
			});
		}
	}

	setVolume = (volume) => {
		if (this.mediaRef.current.volume == 0 && volume > 0) {
			Utility.logUserInteraction('player_unmute', {}, { current_time: this.props.dynamic.currentTime });
		} else if (volume === 0 && this.mediaRef.current.volume !== 0) {
			Utility.logUserInteraction('player_mute', {}, { current_time: this.props.dynamic.currentTime });
		}

		this.mediaRef.current.volume = volume;

		this.props.updatePlayerState({
			volume: volume
		});
	}

	setPlaybackRate(playbackRate) {
		// playbackrate does not change until the video is paused/played in iOS
		if (Browser.ios()) {
			this.mediaRef.current.pause()
		}

		this.mediaRef.current.playbackRate = playbackRate;

		if (Browser.ios()) {
			this.mediaRef.current.play()
		}
	}

	supportsCaptions = () => {
		return this.props.data.recording.info.captions.length;
	}

	loadeddataHandler = () => {
		// console.log('loadeddataHandler');
		this.props.updatePlayerState({
			firstFrameLoaded: true
		});
	}

	loadedmetadataHandler = () => {
		// console.log('loadedmetadataHandler');

		// Hide any CC tracks
		for (let i = 0; i < this.mediaRef.current.textTracks.length; i++) {
			this.mediaRef.current.textTracks[i].mode = 'hidden';
		}

		let duration = this.mediaRef.current.duration;
		let formattedDuration = Utility.sec2hms(duration);
		let time = this.mediaRef.current.currentTime;
		let formattedTime = Utility.sec2hms(time);
		this.mediaRef.current.volume = this.props.data.volume;
		this.mediaRef.current.playbackRate = this.props.data.playbackRate;

		this.props.updateDynamicState({
			currentTime: time,
			formattedTime: formattedTime
		});

		this.props.updatePlayerState({
			duration: duration,
			formattedDuration: formattedDuration,
			volume: this.mediaRef.current.volume,
			playbackRate: this.mediaRef.current.playbackRate
		});

		// Calculate the buffer immediately in case the video is cached
		this.progressHandler();
	}

	progressHandler = () => {
		// console.log('progressHandler');

		if (this.mediaRef.current.buffered) {
			let buffered = this.mediaRef.current.buffered;

			if (buffered.length > 0) {
				let startBuffer = buffered.start(0);
				let endBuffer = buffered.end(0);

				this.props.updateDynamicState({
					startBuffer: startBuffer,
					endBuffer: endBuffer
				});
			}
		}
	}

	canplayHandler = () => {
		// console.log('canplayHandler');
		if (this.loaded === true) { return; }

		this.loaded = true;

		// Hide any CC tracks
		for (let i = 0; i < this.mediaRef.current.textTracks.length; i++) {
			this.mediaRef.current.textTracks[i].mode = 'hidden';
		}

		// set by a `start` URL parameter, but default is 0
		const { autoplay, initialTime } = this.props.data;

		// Don't use this.props.data.duration as it might not have updated at this point yet
		if (initialTime >= 0 && initialTime <= this.mediaRef.current.duration) {
			this.seek(initialTime, autoplay);
		}
	}

	canplaythroughHandler = () => {
		// console.log('canplaythroughHandler');
		// @trigger 'canplaythrough'
		if (this.loaded === false) {
			this.canplayHandler();
		}
	}

	playHandler = () => {
		if (this.loaded === false) { return; }

		this.props.updatePlayerState({
			started: true,
			paused: false,
			ended: false
		});
		this.props.updateDynamicState({
			buffering: true
		});
	}

	pauseHandler = () => {
		if (this.loaded === false) { return; }

		this.props.updatePlayerState({
			paused: true
		});
		this.props.updateDynamicState({
			buffering: false
		});
	}

	waitingHandler = () => {
		// console.log('waitingHandler');
		// if app.browser.ios()
		//   @$el.removeAttr('controls')
		//   @el.pause()
		// return if not @loaded

		this.props.updateDynamicState({
			buffering: true
		});
	}

	playingHandler = () => {
		if (this.loaded === false || this.seeking === true) { return; }

		// @model.set buffering: false
	}

	timeupdateHandler = () => {
		if (this.seeking === true) { return; };
		// return if not @loaded or @model.get 'seeking'

		let time = this.mediaRef.current.currentTime;
		let formattedTime = Utility.sec2hms(time);
		let updateObj = {
			currentTime: time,
			formattedTime: formattedTime
		};

		if (this.props.data.started === true) {
			updateObj.buffering = true;
		}

		this.props.updateDynamicState(updateObj);
		Utility.localStorageSet(this.props.data.recording.recordingkey + '.initialTime', time);

		this.progressHandler();
	}

	endedHandler = () => {
		// console.log('endedHandler');
		this.mediaRef.current.pause()
		this.props.updatePlayerState({
			ended: true
		});
	}

	volumechangeHandler = () => {
		// console.log('volumechangeHandler');
		// @model.set volume: @el.volume
	}

	ratechangeHandler = () => {
		// console.log('ratechangeHandler');
		this.props.updatePlayerState({
			playbackRate: this.mediaRef.current.playbackRate
		});
	}

	seekingHandler = (ev) => {
		var time = this.seekingTime;
		var formattedTime = Utility.sec2hms(time);

		this.seeking = true;

		this.props.updateDynamicState({
			buffering: true,
			currentTime: time,
			formattedTime: formattedTime
		});
	}

	seekedHandler = (ev) => {
		// console.log('seekedHandler', this.mediaRef.current.currentTime);
		// @model.set buffering: true
		// # IE, FF reset playbackrate to 1 on play()
		// if not app.browser.ios()
		//   playbackrate = @model.get 'playbackRate'

		// this.play();

		// if not app.browser.ios()
		//   @setPlaybackRate playbackrate

		clearTimeout(this.seekingDelayTimeUpdateTID);

		// After seeking, get media current time
		this.seekingDelayTimeUpdateTID = Utility.delay(500, () => {
			this.seeking = false;

			this.props.updateDynamicState({
				buffering: false
			});
		}, this);
	}

	render() {
		let videoWrapperStyles = {
			width: '100%',
			height: '100%'
		};

		let videoStyles = {};

		if (this.props.data.useCanvas) {
			// When using canvas, the video element should 100% of size, and hidden
			videoStyles = {
				width: this.props.data.recording.info.movie_exported_width,
				height: this.props.data.recording.info.movie_exported_height,
				position: 'absolute'
			    // visibility: 'hidden'
			    // ,
				// display: 'none'
			}
		} else {
			videoStyles = {
				width: '100%'
			};

			videoWrapperStyles.display = 'flex';
		}

		// synthetic React events we are not using:
		//   onAbort onDurationChange onEmptied onEncrypted
		//   onError onLoadedData onLoadStart
		//   onStalled onSuspend

		// control width/height based on whether or not canvas is being used

		// was on: className="video" onMouseUp={this.playPause}

		return (
			<div className="video" id="tempid" style={videoWrapperStyles}>
				<video
					id="tempvideoid"
					ref={this.mediaRef}

					playsInline={true}
					autoPlay={this.autoplay}
					x-webkit-airplay="allow"
					src={this.props.data.recording.mediaPrefix + this.props.data.recording.sitekey + '/' + this.props.data.recording.info.movie_exported_name + '.' + this.props.data.recording.info.movie_type}
					style={videoStyles}

					controls={this.props.data.useCanvas}
					onContextMenu={(ev) => {ev.preventDefault()}}

					tabIndex="-1"

					onLoadedData={this.loadeddataHandler}
					onLoadedMetadata={this.loadedmetadataHandler}
					onProgress={this.progressHandler}
					onCanPlayThrough={this.canplaythroughHandler}
					onPlay={this.playHandler}
					onPause={this.pauseHandler}
					onClick={this.playPause}
					onWaiting={this.waitingHandler}
					onPlaying={this.playingHandler}
					onTimeUpdate={this.timeupdateHandler}
					onEnded={this.endedHandler}
					onVolumeChange={this.volumechangeHandler}
					onRateChange={this.ratechangeHandler}
					onSeeking={this.seekingHandler}
					onSeeked={this.seekedHandler}
					>
					{ this.supportsCaptions() ? <track kind="captions" label="English captions" src={"/leccap/player/api/webvtt/?rk=" + this.props.data.recording.recordingkey} srcLang="en" /> : null }
				</video>

				{ this.props.data.useCanvas ? <CanvasView playpause={this.playPause} data={this.props.data} dynamic={this.props.dynamic} media={this.mediaRef} bufferCanvas={this.bufferCanvas} bufferCtx={this.bufferCtx} updatePlayerState={this.props.updatePlayerState} /> : null }
				<ReactModal
					isOpen={this.state.autoplayPrevented}
					contentLabel="Autoplay was prevented"
					onRequestClose={this.handleCloseModal}
					shouldCloseOnEsc={false}
					shouldCloseOnOverlayClick={false}
					className="modal"
					overlayClassName="modal-overlay"
					>
					<h2>Autoplay was prevented</h2>
					<p>Please click the play button below to allow playback</p>
					<p className="smaller">This action only needs to be done once</p>
					<div className="modal-toolbar">
						<button onClick={this.allowAutoplayButtonClick}>Play</button>
					</div>
				</ReactModal>
			</div>
		);
	}
}

/*
HTML structure contains the following bits:

Always:
<video autoplay="autoplay" playsinline="true" x-webkit-airplay="allow" src="//s3.amazonaws.com/leccap.engin.umich.edu/media/i8nnmrgfvqkmcyq8wps/1200324961-860-O-c13-1534-22973-12.mp4" width="960" height="480" style="display: none;">
	<track kind="captions" label="English captions" src="//leccap.engin.umich.edu/leccap/viewer/api/webvtt/?rk=qc1X71" srclang="en">
</video>

Optionally:
<canvas width="1067" height="552"></canvas>

Optionally:
<div class="captions captions-collapsed">
	<div class="captions-container"></div>
</div>

*/


const mapStateToProps = (state) => ({
	dynamic: state.dynamic
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(VideoWrapper);


//   ##    ##  #######  ########  ########
//   ###   ## ##     ## ##     ## ##
//   ####  ## ##     ## ##     ## ##
//   ## ## ## ##     ## ##     ## ######
//   ##  #### ##     ## ##     ## ##
//   ##   ### ##     ## ##     ## ##
//   ##    ##  #######  ########  ########

// contains placement information for any drawing objects


class Node {
	constructor(config) {
		// defauls
		var defaults = {
			type: 'node',
			a: 1,
			visible: true,

			src: {
				image: null, // video or buffer canvas
				x: 0,
				y: 0,
				w: 0,
				h: 0
			},
			dest: {
				targetHolderRef: null, // Target ref we are manipulating
				image: null, // image or video or buffer canvas ctx
				x: 0,
				y: 0,
				w: 0,
				h: 0
			}
		};

		this.properties = { ...defaults, ...config };
	}

	draw = () => {
		// if (this.properties.visible === true) {
			switch (this.properties.type) {
				case 'VideoNode':
					// Canvas playback
					this.properties.dest.image.drawImage(
						this.properties.src.image,
						this.properties.src.x, this.properties.src.y, this.properties.src.w, this.properties.src.h,
						this.properties.dest.x, this.properties.dest.y, this.properties.dest.w*window.devicePixelRatio, this.properties.dest.h*window.devicePixelRatio
					);
					break;
				case 'ImageNode':
					if (this.properties.dest.image && this.properties.src.newSrc !== this.properties.src.oldSrc) {
						this.properties.dest.image.src = this.properties.src.newSrc;
						this.properties.src.oldSrc = this.properties.src.newSrc;
					}
					break;
				default:
			}
		// }
	}
}

class NodeList {
	constructor() {
		this.nodes = [];
		this.visible = 0;
	}

	length = () => {
		return this.nodes.length;
	}

	// visibleLength = () => {
	// 	var length = 0;

	// 	for (var i = this.nodes.length - 1; i >= 0; i--) {
	// 		if (this.nodes[i].properties.visible === true) {
	// 			length++;
	// 		}
	// 	}

	// 	return length;
	// }

	add = (node, prepend) => {
		if (prepend === true) {
			this.nodes.unshift(node);
		} else {
			this.nodes.push(node);
		}

		this.visible++;
	}

	hide = (index) => {
		this.nodes[index].properties.visible = false;
		this.visible--;
	}

	show = (index) => {
		this.nodes[index].properties.visible = true;
		this.visible++;
	}

	get = () => {
		return this.nodes;
	}

	set = (sizing) => {
		for (var i = 0; i < sizing.length; i++) {
			if (this.nodes[sizing[i].nodeIndex]) {
				var w = sizing[i].w,
					h = sizing[i].h;

				// Set size of node holders (div)
				this.nodes[sizing[i].nodeIndex].properties.dest.targetHolderRef.current.style.cssText = 'width: ' + w + 'px; height: ' + h + 'px; top: ' + sizing[i].y + 'px; left: ' + sizing[i].x + 'px;';

				// Set destination drawing size
				this.nodes[sizing[i].nodeIndex].properties.dest.w = w;
				this.nodes[sizing[i].nodeIndex].properties.dest.h = h;

				switch (this.nodes[sizing[i].nodeIndex].properties.type) {
					case 'VideoNode':
						// Set size of canvas element
						this.nodes[sizing[i].nodeIndex].properties.dest.canvas.width = w*window.devicePixelRatio;
						this.nodes[sizing[i].nodeIndex].properties.dest.canvas.height = h*window.devicePixelRatio;
						break;

					default:
				}
			}
		}
	}
}

/*
NodeViews =
	Node: class NodeView extends Backbone.View
		initialize: (options) ->
			@options = options
			@on 'all', (args...) => @view?.trigger.apply @view, args
			@model.view = @

	ImageNode: class ImageNodeView extends NodeView
		draw: ->
			node = @model.toJSON()
			src = node.src
			ctx = @options.ctx
			if node.visible and src?.image? and src.image.width > 0 and src.image.height >0 and src.w > 0 and src.h > 0
				ctx.save()
				ctx.globalAlpha = node.a
				ctx.drawImage src.image, src.x, src.y, src.w, src.h, node.x, node.y, node.w, node.h
				ctx.restore()
*/





//    ######     ###    ##    ## ##     ##    ###     ######
//   ##    ##   ## ##   ###   ## ##     ##   ## ##   ##    ##
//   ##        ##   ##  ####  ## ##     ##  ##   ##  ##
//   ##       ##     ## ## ## ## ##     ## ##     ##  ######
//   ##       ######### ##  ####  ##   ##  #########       ##
//   ##    ## ##     ## ##   ###   ## ##   ##     ## ##    ##
//    ######  ##     ## ##    ##    ###    ##     ##  ######



class CanvasView extends Component {
	/*
		Since we won't be using React to redraw the Canvas element, except for resize events, we
	*/

	constructor(props) {
		super(props);

		this.stageRef = React.createRef();

		// requestAnimationFrame ID, needed to start/stop etc...
		this.frameId = null;

		// Tracks +/- button exit, currenlty BROKEN, TODO fix
		this.sizeButtonIntervalTID = null;

		// Used to "track" FPS for throttling purposes
		this.last = 0;
		this.frames = 0;
		this.framesArray = [];
		this.videoNodes = new NodeList();

		this.sizeRatios = [];

		this.state = {
			toggledSource: false
		};

		if (this.props.data.enabledPresets.video === 1 || this.props.data.enabledPresets.legacyVideo === 1) {
			if (this.props.data.enabledPresets.video === 1) {
				this.videoNodes.add(new Node({
					label: 'Video',
					type: 'VideoNode',
					ratio: +this.props.data.recording.info.movie_exported_video_width / +this.props.data.recording.info.movie_exported_video_height,
					src: {
						image: this.props.bufferCanvas,
						x: +this.props.data.recording.info.movie_exported_video_left,
						y: +this.props.data.recording.info.movie_exported_video_top,
						w: +this.props.data.recording.info.movie_exported_video_width,
						h: +this.props.data.recording.info.movie_exported_video_height
					},
					dest: {
						targetHolderRef: React.createRef(),
						x: 0,
						y: 0,
						w: 0,
						h: 0
					}
				}), false);
			}

			if (this.props.data.enabledPresets.legacyVideo === 1) {
				this.videoNodes.add(new Node({
					label: 'Video',
					type: 'VideoNode',
					ratio: +this.props.data.recording.info.movie_exported_width / +this.props.data.recording.info.movie_exported_height,
					src: {
						image: this.props.bufferCanvas,
						x: 0,
						y: 0,
						w: +this.props.data.recording.info.movie_exported_width,
						h: +this.props.data.recording.info.movie_exported_height
					},
					dest: {
						targetHolderRef: React.createRef(),
						x: 0,
						y: 0,
						w: 0,
						h: 0
					}
				}), false);
			}
		}

		if (this.props.data.enabledPresets.slides === 1) {
			var prepend = false;

			if (+this.props.data.recording.info.movie_exported_video_left > 0) {
				prepend = true;
			}

			this.videoNodes.add(new Node({
				label: 'Slides',
				type: 'VideoNode',
				ratio: +this.props.data.recording.info.movie_exported_slides_width / +this.props.data.recording.info.movie_exported_slides_height,
				src: {
					image: this.props.bufferCanvas,
					x: +this.props.data.recording.info.movie_exported_slides_left,
					y: +this.props.data.recording.info.movie_exported_slides_top,
					w: +this.props.data.recording.info.movie_exported_slides_width,
					h: +this.props.data.recording.info.movie_exported_slides_height
				},
				dest: {
					targetHolderRef: React.createRef(),
			        x: 0,
			        y: 0,
			        w: 0,
			        h: 0
				}
			}), prepend);
		}

		for(var i = 0; i < this.props.data.enabledPresets.aux.length; i++) {
			var source = this.props.data.enabledPresets.aux[i];

			this.videoNodes.add(new Node({
				label: source.name,
				type: 'ImageNode',
				ratio: source.width / source.height,
				src: {
					prefix: source.prefix,
					images: source.images,
					newSrc: PlaceholderImage,
					oldSrc: ''
				},
				dest: {
					targetHolderRef: React.createRef()
				}
			}), false);
		}
	}

	componentDidMount() {
		// set timer here
		document.addEventListener('player.changesourcesize', this.changeSizeHandler);
		this.props.media.current.addEventListener('loadeddata', this.loadeddataHandler);

		// Assign refs
		for (var i = 0; i < this.videoNodes.nodes.length; i++) {
			// Assign a default size ratio
			this.sizeRatios.push(4);

			// // Image is a child of the nodeHolder ref
			if (this.videoNodes.nodes[i].properties.type === 'VideoNode') {
				this.videoNodes.nodes[i].properties.dest.canvas = this.videoNodes.nodes[i].properties.dest.targetHolderRef.current.querySelector('canvas');
				this.videoNodes.nodes[i].properties.dest.image = this.videoNodes.nodes[i].properties.dest.targetHolderRef.current.querySelector('canvas').getContext('2d', { alpha: false });
			}

			if (this.videoNodes.nodes[i].properties.type === 'ImageNode') {
				this.videoNodes.nodes[i].properties.dest.image = this.videoNodes.nodes[i].properties.dest.targetHolderRef.current.querySelector('img');
			}
		}

		this.start(); // THIS DOES NOT BELONG HERE - or does it?
	}

	componentWillUnmount() {
		// remove timer
		document.removeEventListener('player.changesourcesize', this.changeSizeHandler);
		if (this.props.media.current) {
			this.props.media.current.removeEventListener('loadeddata', this.loadeddataHandler);
		}

		this.stop(); // THIS DOES NOT BELONG HERE - or does it?
	}

	loadeddataHandler = (ev) => {
		this.draw();

		// Chrome doesn't reliably render the first frame when this is first called
		Utility.delay(500, () => { this.draw() }, this);
	}

	shouldComponentUpdate(nextProps, nextState) {
		// If the time changes, instruct videoNodes to update static image-based nodes
		if (Math.round(this.props.dynamic.currentTime) !== Math.round(nextProps.dynamic.currentTime)) {
			var imageRef = null,
				imageUrl;

			for (var i = this.videoNodes.nodes.length - 1; i >= 0; i--) {
				// TODO: might be a more performant way of doing this - maybe create an array of node indexes
				if (this.props.data.visiblePresets.stage[i].visible === true && this.videoNodes.nodes[i].properties.type === 'ImageNode') {
					imageRef = Utility.getThingByTime(Math.round(nextProps.dynamic.currentTime), this.videoNodes.nodes[i].properties.src.images);
					imageUrl = Utility.getImageUrl(this.props.data.baseImageUrl, this.videoNodes.nodes[i].properties.src.prefix, imageRef[0]);
					if (imageUrl === null) {
						imageUrl = 'data:image/gif;base64,R0lGODlhAgACAMQAAAAAAAgHCAwMDBAPEBQUFBgXGBoaGiMjIysrKzMzMzs7O0NDQ0tLS1NTU1tbW2RkZGtra3R0dHt7e4SEhIuLi5OTk5ubm6SkpKmpqbGxsQAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAaACwAAAAAAgACAAAFBCAhEiEAOw==';
					}
					this.videoNodes.nodes[i].properties.src.newSrc = imageUrl
					this.videoNodes.nodes[i].draw();
				}
			}
		}

		// Time changed and we are paused - redraw a few times
		if (this.props.dynamic.currentTime !== nextProps.dynamic.currentTime && nextProps.data.paused === true) {
			this.draw(0);
			Utility.delay(500, () => { this.draw(0); }, this);
			Utility.delay(750, () => { this.draw(0); }, this);
			Utility.delay(1000, () => { this.draw(0); }, this);
		}

		// when playback is paused, stop canvas updates
		// We check to make sure the first poster frame is loaded
		if (this.frameId && nextProps.data.paused && nextProps.data.firstFrameLoaded) {
			this.stop();
		} else if (!this.frameId && !nextProps.data.paused) {
			this.start();
		}

		if (this.props.data.dimensions.windowWidth !== nextProps.data.dimensions.windowWidth ||
			this.props.data.dimensions.windowHeight !== nextProps.data.dimensions.windowHeight) {
			return true;
		}

		if (JSON.stringify(this.props.data.visiblePresets.stage) !== JSON.stringify(nextProps.data.visiblePresets.stage)) {
			return true;
		}

		// On size change - compare windowWidth and windowHeight and redraw if necessary
		return false;
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(this.props.data.visiblePresets.stage) !== JSON.stringify(prevProps.data.visiblePresets.stage)) {
			this.recalcStage();
		}
	}

	onResizeStage = (width, height) => {
		// this.whiteboardRef.current.height = height;
		this.recalcStage();
	}

	countVisible = () => {
		var count = 0;

		for (var i = this.props.data.visiblePresets.stage.length - 1; i >= 0; i--) {
			if (this.props.data.visiblePresets.stage[i].visible === true) {
				count++;
			}
		}

		return count;
	}

	recalcStage = () => {
		// console.log('RECALC STAGE');
		var gutter = 0,
			numberContent = this.countVisible(),
			percents = [
				0,
				.25,
				.50,
				.75,
				1.00
			],
			i = 0, // General use iterator
			percentShrink = 0,
			nodeSizing = {},
			maxRatio = 0;

		for (i = 0; i < this.sizeRatios.length; i++) {
			if (this.props.data.visiblePresets.stage[i].visible === true) {
				maxRatio = Math.max(maxRatio, this.sizeRatios[i]);
			}
		}

		var addToRatio = 4 - maxRatio;

		var chosenSizing = {},
			sizingHorizontal = { type: 'horizontal', renderBoxes: [] },
			sizingVertical = { type: 'vertical', renderBoxes: [] };

		var containerWidth = this.stageRef.current.clientWidth,
			containerHeight = this.stageRef.current.clientHeight;

		// Available Area
		var availableWidth = (containerWidth - (gutter*(1+numberContent))),
			availableHeight = (containerHeight - (gutter*(1+numberContent)));

		if (containerWidth > containerHeight) {
		// if (sizingHorizontal.video.w*sizingHorizontal.video.h >= sizingVertical.video.w*sizingVertical.video.h) {

			// Horizontal layout strategy
			var maxContentHeight = availableHeight;

			var calculatedContentWidth = 0;

			for (i = 0; i < this.videoNodes.nodes.length; i++) {
				if (this.props.data.visiblePresets.stage[i].visible === true) {
					nodeSizing = {
						nodeIndex: i,
						w: maxContentHeight * this.videoNodes.nodes[i].properties.ratio*(percents[this.sizeRatios[i]+addToRatio]),
						h: maxContentHeight * (percents[this.sizeRatios[i]+addToRatio])
					};

					sizingHorizontal.renderBoxes.push(nodeSizing);

					calculatedContentWidth += nodeSizing.w;
				}
			}

			// Shrink
			if (calculatedContentWidth > availableWidth) {
				percentShrink = availableWidth / calculatedContentWidth;

				calculatedContentWidth = 0;

				for (i = 0; i < numberContent; i++) {
					sizingHorizontal.renderBoxes[i].w *= percentShrink;
					sizingHorizontal.renderBoxes[i].h *= percentShrink;

					calculatedContentWidth += sizingHorizontal.renderBoxes[i].w;
				}
			}

			var leftOffset = (containerWidth - (calculatedContentWidth + (numberContent-1)*gutter)) / 2;

			// Set left offset & vertical
			for (i = 0; i < numberContent; i++) {
				sizingHorizontal.renderBoxes[i].x = leftOffset;

				// Calculate new left offset
				leftOffset += sizingHorizontal.renderBoxes[i].w + gutter;

				sizingHorizontal.renderBoxes[i].y = gutter + (containerHeight - 2*gutter - sizingHorizontal.renderBoxes[i].h)/2;
			}

			chosenSizing = sizingHorizontal;
		} else {
			// Vertical layout strategy

			var maxContentWidth = availableWidth;

			var calculatedContentHeight = 0;

			for (i = 0; i < this.videoNodes.nodes.length; i++) {
				if (this.props.data.visiblePresets.stage[i].visible === true) {
					nodeSizing = {
						nodeIndex: i,
						w: maxContentWidth * (percents[this.sizeRatios[i]+addToRatio]),
						h: maxContentWidth / this.videoNodes.nodes[i].properties.ratio*(percents[this.sizeRatios[i]+addToRatio])
					};

					sizingVertical.renderBoxes.push(nodeSizing);

					calculatedContentHeight += nodeSizing.h;
				}
			}

			// Shrink
			if (calculatedContentHeight > availableHeight) {
				percentShrink = availableHeight / calculatedContentHeight;

				calculatedContentHeight = 0;

				for (i = 0; i < numberContent; i++) {
					sizingVertical.renderBoxes[i].w *= percentShrink;
					sizingVertical.renderBoxes[i].h *= percentShrink;

					calculatedContentHeight += sizingVertical.renderBoxes[i].h;
				}
			}

			var topOffset = (containerHeight - (calculatedContentHeight + (numberContent-1)*gutter)) / 2;

			// Set top offset & horizontal
			for (i = 0; i < numberContent; i++) {
				sizingVertical.renderBoxes[i].y = topOffset;

				// Calculate new left offset
				topOffset += sizingVertical.renderBoxes[i].h + gutter;

				sizingVertical.renderBoxes[i].x = gutter + (containerWidth - 2*gutter - sizingVertical.renderBoxes[i].w)/2;
			}

			chosenSizing = sizingVertical;
		}

		this.videoNodes.set(chosenSizing.renderBoxes);

		// After resizing canvas, it goes all black so we need to redraw the frames
		this.draw(0);
	}


/*

Canvas element:
	initialize: (options) ->
		@model.childNodes.on 'add remove', @updateNodes, @
		@ctx = @el.getContext '2d'

	cleanup: ->
		@model.childNodes.off null, null, @
		@stop()
		CoffeeMation.cancelAll 'canvas'

*/
	throttle = (time) => {
		if (this.props.data.throttle) {
			if (time - this.last >= 1000) {
				var oldFPS = window.appGlobals.maxFPS,
					avgFPS = Math.round(this.frames / (time - this.last) * 10000)/10;

				this.last = time;
				this.frames = 0;
				this.framesArray.push(avgFPS);

				if (this.framesArray.length > 11) {
					this.framesArray.shift()
					var x = this.framesArray.length - 1;
					var sum = 0;
					var average = 0;

					while (x > -1) {
						sum += this.framesArray[x];
						x--;
					}

					average = sum / this.framesArray.length;

					if (average > 23) {
						window.appGlobals.maxFPS = 30;
					} else if (average > 18) {
						window.appGlobals.maxFPS = 25;
					} else if (average > 13) {
						window.appGlobals.maxFPS = 20;
					} else if (average > 8) {
						window.appGlobals.maxFPS = 15;
					} else if (average > 3) {
						window.appGlobals.maxFPS = 10;
					} else if (average > 0) {
						window.appGlobals.maxFPS = 5;
					}

					if (oldFPS !== window.appGlobals.maxFPS) {
						window.appGlobals.minInterval = 1000 / window.appGlobals.maxFPS;
					}
				}
			}

			this.frames++;
		}
	}

	start = () => {
		if (this.frameId) {
			return;
		}

		this.stop();

		var last = 0;

		var renderFrame = (time) => {
			if (time - last >= window.appGlobals.minInterval) {
				this.throttle(time);
				this.draw(time);
				last = time;
			}

			this.frameId = requestAnimationFrame(renderFrame);
		}

		renderFrame(last);
	}

	stop = () => {
		cancelAnimationFrame(this.frameId)
		this.frameId = null;
	}

/*
	updateNodes: ->
		@childNodes = []
		@model.childNodes.each (node) =>
			node.view ||= new NodeViews[node.get 'type']
				ctx: @ctx
				model: node
			@childNodes.push node.view

		if @childNodes.length
			@start()
		else
			@stop()
*/
	beforeDraw = () => {
		// copy video frame from buffer canvas to image buffer canvas
		// var bufferCanvas = document.getElementById('canvassey');
		// var bufferCtx = bufferCanvas.getContext('2d', { alpha: false });

		// var video = document.getElementById('tempvideoid');

		// bufferCtx.clearRect(0, 0, bufferCanvas.width, bufferCanvas.height);
		// bufferCtx.fillStyle = "#FF0000";
		// bufferCtx.fillRect(20, 20, 150, 100);
		// bufferCtx.drawImage(video, 0, 0);
		this.props.bufferCtx.drawImage(this.props.media.current, 0, 0);

		// document.getElementById('canvassey').getContext('2d', { alpha: false }).clearRect(0, 0, document.getElementById('canvassey').width, document.getElementById('canvassey').height);document.getElementById('canvassey').getContext('2d', { alpha: false }).drawImage(document.getElementById('tempvideoid'), 0, 0);
	}

	draw = (time) => {
		this.beforeDraw();
		for (var i = this.videoNodes.nodes.length - 1; i >= 0; i--) {
			// TODO: might be a more performant way of doing this - maybe create an array of node indexes
			if (this.props.data.visiblePresets.stage[i].visible === true && this.videoNodes.nodes[i].properties.type === 'VideoNode') {
				this.videoNodes.nodes[i].draw();
			}
		}
	}

	changeSizeHandler = (ev) => {
		this.changeSize(ev.detail.target, ev.detail.action);
	}

	changeSize = (target, action) => {
		var i = 0;

		if (action === 'bigger') {
			this.sizeRatios[target] = this.sizeRatios[target] + 1;

			if (this.sizeRatios[target] > 4) {
				this.sizeRatios[target] = 4;

				for (i = 0; i < this.sizeRatios.length; i++) {
					if (i !== target) {
						this.sizeRatios[i] = Math.max(1, this.sizeRatios[i]-1);
					}
				}
			}
		} else {
			this.sizeRatios[target] = this.sizeRatios[target] - 1;

			if (this.sizeRatios[target] < 1) {
				this.sizeRatios[target] = 1;

				for (i = 0; i < this.sizeRatios.length; i++) {
					if (i !== target) {
						this.sizeRatios[i] = Math.min(4, this.sizeRatios[i] + 1);
					}
				}
			}

			this.sizeRatios[target] = Math.max(1, this.sizeRatios[target]);
		}

		// Bring all values up to 4
		var maxRatio = Math.max(...this.sizeRatios);

		if (maxRatio < 4) {
			var add = 4 - maxRatio;

			// Now bring all size ratios up to 4
			for (i = 0; i < this.sizeRatios.length; i++) {
				this.sizeRatios[i] = this.sizeRatios[i] + add;
			}
		}

		this.recalcStage();
	}

	sizeButtonsEnter = (ev) => {
		if (this.sizeButtonIntervalTID) {
			clearTimeout(this.sizeButtonIntervalTID);
		}

		// Get offset of the parentElement
		var offset = Utility.offset(ev.target.parentElement);

		var props = [
			'position: fixed',
			'left: ' + offset.left + 'px',
			'top: ' + offset.top + 'px'
		];

		if (ev.target.className === 'sizebuttons') {
			ev.target.style.cssText = props.join(';');
		} else if (ev.target.parentElement.className === 'sizebuttons') {
			ev.target.parentElement.style.cssText = props.join(';');
		}
	}

	sizeButtonsLeave = (ev) => {
		let element = ev.target;

		// this.sizeButtonIntervalTID = Utility.delay(500, () => {
		// 	console.log('intervaled!');
			if (element.className === 'sizebuttons') {
				element.style.cssText = '';
			} else if (element.parentElement.className === 'sizebuttons') {
				element.parentElement.style.cssText = '';
			}
		// }, element);
	}

	closeButtonPressed = (index) => {
		var tempVisiblePresets = JSON.parse(JSON.stringify(this.props.data.visiblePresets));

		tempVisiblePresets.stage[index].visible = !tempVisiblePresets.stage[index].visible;

		this.props.updatePlayerState({
			visiblePresets: tempVisiblePresets
		});
	}

	onstageclickHandler = (ev) => {
		this.props.playpause();
	}

	render() {
		console.log('--============================== RENDER CANVAS ==============================--');
		// <canvas style={{border: '1px #FFF solid'}} width={this.props.data.dimensions.windowWidth} height={this.props.data.dimensions.windowHeight}></canvas>

		return (
			<div style={{ height: '100%' }}>
					<div ref={this.stageRef} id="stage" onClick={this.onstageclickHandler}>
						{ this.videoNodes.nodes.map((node, index) => {
							return(<div key={index} ref={node.properties.dest.targetHolderRef} className={'renderedbox renderbox-' + index + (this.props.data.visiblePresets.stage[index].visible === false ? ' hide' : '')}>
										<div className="element-wrap">{ node.properties.type === 'VideoNode' ? <canvas></canvas> :  <img alt="aux source" src={PlaceholderImage} /> }</div>
										<div className="source-toolbar">
											<CloseButtonView sourceIndex={index} onButtonToggle={this.closeButtonPressed} nameLabel={node.properties.label} />
											<div className="namelabel">{ node.properties.label }</div>
										</div>
									</div>
							)
						}) }
						<ReactResizeDetector handleWidth handleHeight onResize={this.onResizeStage} />
					</div>
			</div>
		);
	}
}

class CloseButtonView extends Component {
	onClickHandler = (ev) => {
		this.props.onButtonToggle(this.props.sourceIndex);
		ev.stopPropagation();
	}

	render() {
		return(
			<button tabIndex="0" onClick={this.onClickHandler} className="ui-button closebutton"><span className="visuallyhidden">Close {this.props.nameLabel} </span> <IconClose /></button>
		);
	}
}